import { AddCustomWorkListRequest } from "@tm/models"
import { WorkTaskInfo } from "@tm/context-distribution"
import { CostEstimation } from "../../../../../data/model"
import { BasicBasketWorkInfo } from "../../../../../models"
import { WorkEditDialog } from "./WorkEdit/WorkEditDialog"

type Props = {
    workTask: WorkTaskInfo
    costEstimation?: CostEstimation
    repairTimeDivision: number
    showRepairTimesInHours: boolean
    disableHeaderButtons: boolean
    onAddCustomWork(request: AddCustomWorkListRequest): void
    onClose(): void
}

export function NewCustomWorkDialog(props: Props) {
    const { costEstimation, workTask, repairTimeDivision, showRepairTimesInHours, disableHeaderButtons, onAddCustomWork, onClose } = props
    const { id, vehicle } = workTask
    const { costEstimationOptions } = costEstimation || {}

    async function handleAddCustomWorkClick(editBasketWorkInfo: BasicBasketWorkInfo) {
        const { categoryOfWork, description, workNumber, time, hourlyRate, fixedPriceValue, vatRate, rebate, surcharge } = editBasketWorkInfo

        onAddCustomWork({
            workTaskId: id,
            repairTimeDivision,
            customWorks: [
                { customWorkNumber: workNumber, categoryOfWork, description, time, hourlyRate, fixedPriceValue, rebate, surcharge, vatRate },
            ],
            vehicleId: vehicle?.id,
            usePercentageValues: true,
            costEstimationOptions,
        })
    }

    if (!costEstimation) {
        return null
    }

    return (
        <WorkEditDialog
            disableHeaderButtons={disableHeaderButtons}
            showRepairTimesInHours={showRepairTimesInHours}
            repairTimeDivision={repairTimeDivision}
            workInfo={{ type: "add" }}
            onCloseButtonClick={onClose}
            onAddCustomWork={handleAddCustomWorkClick}
        />
    )
}
